const VIDEO_CODECS = ['vp8', 'vp9', 'avc1', 'av01', 'hevc', 'theora', 'h264'];
const AUDIO_CODECS = ['opus', 'aac', 'mp3', 'vorbis', 'flac', 'wav'];
export class CapabilityManager {
    static instance = null;
    flags;
    gpu;
    codecs;
    maxQualityTier;
    userAgent;
    constructor() {
        this.userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : 'node';
        this.flags = this.detectFlags();
        this.gpu = this.detectGpu();
        this.codecs = this.detectCodecs();
        this.maxQualityTier = this.computeMaxQualityTier();
    }
    static getInstance() {
        if (!CapabilityManager.instance) {
            CapabilityManager.instance = new CapabilityManager();
        }
        return CapabilityManager.instance;
    }
    static resetForTesting(flags) {
        const manager = new CapabilityManager();
        Object.assign(manager.flags, flags);
        return manager;
    }
    supports(feature) {
        return this.flags[feature];
    }
    detectFlags() {
        if (typeof navigator === 'undefined' || typeof document === 'undefined') {
            return {
                webgpu: false,
                webgl2: false,
                webcodecs: false,
                offscreenCanvas: false,
                workers: true,
                webAudio: false,
                fileSystemAccess: false,
                wasm: true,
                indexedDB: typeof indexedDB !== 'undefined',
                sharedArrayBuffer: typeof SharedArrayBuffer !== 'undefined',
                mediaCapabilities: false,
            };
        }
        const nav = navigator;
        const canvas = document.createElement('canvas');
        const global = globalThis;
        return {
            webgpu: typeof nav.gpu?.requestAdapter === 'function',
            webgl2: canvas.getContext('webgl2') !== null,
            webcodecs: typeof globalThis.VideoEncoder === 'function' &&
                typeof globalThis.VideoFrame === 'function',
            offscreenCanvas: typeof OffscreenCanvas !== 'undefined',
            workers: typeof Worker !== 'undefined',
            webAudio: typeof AudioContext !== 'undefined' || typeof global.webkitAudioContext === 'function',
            fileSystemAccess: typeof window !== 'undefined' &&
                typeof window.showOpenFilePicker ===
                    'function',
            wasm: typeof WebAssembly !== 'undefined' && typeof WebAssembly.compile === 'function',
            indexedDB: typeof indexedDB !== 'undefined',
            sharedArrayBuffer: typeof SharedArrayBuffer !== 'undefined',
            mediaCapabilities: typeof nav.mediaCapabilities?.decodingInfo === 'function',
        };
    }
    detectGpu() {
        if (!this.flags.webgpu)
            return null;
        const nav = navigator;
        if (!nav.gpu?.requestAdapter)
            return null;
        // Synchronous snapshot; real limits resolved async via GpuContext
        return {
            maxTextureDimension2D: 0,
            maxBufferSize: 0,
            maxComputeWorkgroupStorageSize: 0,
            maxComputeInvocationsPerWorkgroup: 0,
            maxStorageBufferBindingSize: 0,
        };
    }
    detectCodecs() {
        if (!this.flags.mediaCapabilities)
            return null;
        const nav = navigator;
        const video = {};
        for (const codec of VIDEO_CODECS) {
            video[codec] = false;
            void nav.mediaCapabilities
                ?.decodingInfo({ type: 'file', video: { contentType: `video/${codec}` } })
                .then((r) => {
                video[codec] = r.supported;
            })
                .catch(() => {
                video[codec] = false;
            });
        }
        const audio = {};
        for (const codec of AUDIO_CODECS) {
            audio[codec] = false;
            void nav.mediaCapabilities
                ?.decodingInfo({ type: 'file', audio: { contentType: `audio/${codec}` } })
                .then((r) => {
                audio[codec] = r.supported;
            })
                .catch(() => {
                audio[codec] = false;
            });
        }
        return { video, audio };
    }
    computeMaxQualityTier() {
        if (!this.flags.webgpu && !this.flags.webgl2)
            return 'DRAFT';
        if (!this.flags.webgpu)
            return 'PREVIEW';
        if (!this.flags.offscreenCanvas || !this.flags.workers)
            return 'HIGH';
        return 'MASTER';
    }
}
//# sourceMappingURL=capability-manager.js.map